/**
 * Returns true if `browserLang` matches `configured` using BCP 47 prefix semantics:
 * - Exact match: 'ja-JP' matches 'ja-JP'
 * - Prefix match: 'ja' matches 'ja-JP' (configured 'ja' covers all Japanese variants)
 */
export function matchesLocale(
  browserLang: string,
  configured: string
): boolean {
  const a = browserLang.toLowerCase();
  const b = configured.toLowerCase();
  return a === b || a.startsWith(`${b}-`);
}
